import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/_shared/shared.service';
import { RepService } from '../../services/rep.service';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {

  activeTab = 1;

  // Tabs configuration for s-table
  tabUpcoming = {
    refreshUrl: 'reservations/list',
    params: { tab: 'UPCOMING' },
    detailUrl: 'admin/reservations',
    detailId: 'id_reservation',
    cols: [
      { type: 'datetime', attr: 'date_from', tdStyle: 'width: 15%' },
      { type: 'datetime', attr: 'date_to', tdStyle: 'width: 15%' },
      { type: 'text', attr: 'location_name' },
      { type: 'text', attr: 'station_name' },
      { type: 'text', attr: 'user_name' },
      { type: 'text', attr: 'client_name' },
      { type: 'text', attr: 'license_plate' },
      { type: 'number', attr: 'energy_kwh', suffix: ' kWh' },
      { type: 'translate', attr: 'status', transPrefix: 'rep.status.' }
    ]
  };

  tabAll = {
    refreshUrl: 'reservations/list',
    params: { tab: 'ALL' },
    detailUrl: 'admin/reservations',
    detailId: 'id_reservation',
    cols: [
      { type: 'datetime', attr: 'date_from', tdStyle: 'width: 12%' },
      { type: 'datetime', attr: 'date_to', tdStyle: 'width: 12%' },
      { type: 'text', attr: 'location_name' },
      { type: 'text', attr: 'station_name' },
      { type: 'text', attr: 'user_name' },
      { type: 'text', attr: 'client_name' },
      { type: 'text', attr: 'license_plate' },
      { type: 'number', attr: 'energy_kwh', suffix: ' kWh' },
      { type: 'translate', attr: 'status', transPrefix: 'rep.status.', searchType: 'select',
        options: [
          { value: 'PENDING', text: 'rep.status.PENDING' },
          { value: 'CONFIRMED', text: 'rep.status.CONFIRMED' },
          { value: 'CANCELLED', text: 'rep.status.CANCELLED' },
          { value: 'COMPLETED', text: 'rep.status.COMPLETED' }
        ]
      },
      { type: 'date', attr: 'created_at' }
    ]
  };

  tabToday = {
    refreshUrl: 'reservations/list',
    params: { tab: 'TODAY' },
    detailUrl: 'admin/reservations',
    detailId: 'id_reservation',
    cols: [
      { type: 'time', attr: 'date_from', tdStyle: 'width: 10%' },
      { type: 'time', attr: 'date_to', tdStyle: 'width: 10%' },
      { type: 'text', attr: 'location_name' },
      { type: 'text', attr: 'station_name' },
      { type: 'text', attr: 'user_name' },
      { type: 'text', attr: 'client_name' },
      { type: 'text', attr: 'license_plate' },
      { type: 'number', attr: 'energy_kwh', suffix: ' kWh' },
      { type: 'translate', attr: 'status', transPrefix: 'rep.status.' }
    ]
  };

  constructor(
    public shared: SharedService,
    private repService: RepService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.activeTab = this.shared.loadActiveTab('rep_admin_tab', false, 1);
  }

  onTabChange(): void {
    this.shared.saveActiveTab('rep_admin_tab', false, this.activeTab);
  }

  createReservation(): void {
    this.router.navigate(['/admin/reservations/new']);
  }
}
